
export const seoConfig = {
  baseUrl: "https://onarrivebientot.nlocale.fr",
  defaultTitle: "Découvrez l'Aisne : Laon, Soissons, Saint-Quentin | NLocale",
  defaultDescription: "Explorez les meilleures adresses de l'Aisne : restaurants, hébergements et activités à Laon, Soissons et Saint-Quentin. Guide local authentique pour vivre des expériences uniques.",
  defaultImage: "https://onarrivebientot.nlocale.fr/lovable-uploads/2bf80316-0d59-4fe5-a7f1-92a8ec5447b7.png",
  social: {
    facebook: "https://facebook.com/profile.php?id=61572375376059",
    twitter: "https://x.com/NLocaleFr",
    instagram: "https://instagram.com/nlocalfr/",
    telegram: "https://t.me/nlocalefr",
    whatsapp: "https://wa.me/33766668222",
    messenger: "https://m.me/nlocalefr"
  }
} as const;
